import React, {useEffect, useState } from "react";
import {Card,CardBody,Button,Col,Container,Row,Alert,} from "reactstrap";
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";

import axios from "axios";
//Import Breadcrumb
import Breadcrumbs from "../../../Components/Common/Breadcrumb";


interface PackageItem {
    id: number;
    duration: string;
    price: string;
}

// interface DurationPriceInput {
//     id: number;
//     duration: string;
//     price: string;
// }

function Exp_package(props: any) {

const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
};
const [showloader, setshowloader] = useState(true);

// meta title
document.title = "Package | BizServe";

// State for packages
const [packages, setPackages] = useState<PackageItem[]>([
    // { id: 1, duration: "3 Hours", price: "$500" },
]);

const [durationPriceInputs, setDurationPriceInputs] = useState([
    { id: 1, duration: "", price: "" },
]);

// const updateDurationPriceInputs = (packDetails) => {
//     console.log('packDetails updateDurationPriceInputs ________',packDetails)
//     const updatedInputs = packDetails.map((pack) => ({
//         id: pack.id,
//         duration: pack.session_mins,
//         price: pack.price,
//     }));
//     setDurationPriceInputs(updatedInputs);
// };
const addDurationPriceInput = () => {
    const newId = durationPriceInputs.length > 0 
    ? Math.max(...durationPriceInputs.map(input => input.id)) + 1 
    : 1;
    setDurationPriceInputs([
    ...durationPriceInputs,
    { id: newId, duration: "", price: "" },
    ]);
};

const removeDurationPriceInput = (id: number) => {
    if (durationPriceInputs.length > 1) {
    setDurationPriceInputs(durationPriceInputs.filter(input => input.id !== id));
    }
};



const handleInputChange = (id: number, field: string, value: string) => {
    // Basic validation - only allow numbers
    if (field === 'duration' || field === 'price') {
        if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
            setDurationPriceInputs(
                durationPriceInputs.map(input =>
                    input.id === id ? { ...input, [field]: value } : input
                )
            );
        }
    }
};


const addAvailBtn = async() => {
    try{
    setshowloader(true)
    const response = await axios.get('accounts/get_expert_settings',{withCredentials:true,headers: { "Content-Type": "application/json", },});
    if (response.status === 'SENT'){ 
        setshowloader(false)
        setPackages([]);
        const hour_time = response.expert.policy_time
        console.log('pack_details ________________',hour_time)
        const pack_details = response.expert.packs || [];
        console.log('pack_details ________________',pack_details)
        const convertedPackages = pack_details.map((pack: any) => ({
            id: pack.id,
            duration: `${pack.session_mins} Minutes`,
            price: `$${pack.price}`,
        }));
        console.log('Converted Packages:', convertedPackages);
        setPackages((prev) => [...prev, ...convertedPackages]);
        // setDurationPriceInputs([...durationPriceInputs, ...convertedPackages]);
        const inputFields = pack_details.map((pack: any) => ({
            id: pack.id,
            duration: pack.session_mins.toString(),
            price: pack.price.toString(),
        }));
        
        setHours(hour_time)
        // If no existing packages, keep one empty input
        if (inputFields.length === 0) {
            setDurationPriceInputs([{ id: 1, duration: "", price: "" }]);
        } else {
            setDurationPriceInputs(inputFields);
        }
        // updateDurationPriceInputs(convertedPackages);
    }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
            console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    }

useEffect(() => {
    addAvailBtn();
    subscribeToTokenRefresh(() => {
        console.log("🔁 Token refreshed. Re-fetching experts...");
        addAvailBtn();
    });
}, []);



const savePackages = async () => {
    const ipacks = durationPriceInputs
    .filter(input => input.duration && input.price)
    .map((input, index) => ({
        id: packages.length + index + 1,
        duration: input.duration,
        price: input.price,
    }));
    console.log('newPackages--------------------',ipacks)
    try{
    if (ipacks.length > 0) {
        setshowloader(true)
        const response = await axios.post('accounts/update_exp_packs', {ipacks: ipacks}, {withCredentials:true,headers: { "Content-Type": "application/json", },});
        console.log('response ka data',response)
        if (response.status === 'UPDATED') {
            setshowloader(false)
            console.log('response ka data aagya h ',response)
            addAvailBtn();
        }
            // {setAlertMsgg({ ...alertMsgg, open: true, content:"Prices updated!", type:"success" })}
        // Reset inputs except one
        // setDurationPriceInputs([{ id: 1, duration: "", price: "" }]);
    }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
};

const [hours, setHours] = useState("");

const handleCpolicy = (e) => {
    setHours(e.target.value);
};

const saveHours = async () => {
    const formData = new FormData();
    formData.append("hours", hours);
    formData.append("action", 'Set_pack_time');

    try{
        setshowloader(true)
        const response = await axios.post('accounts/update_exp_packs', formData, {withCredentials:true,headers: { "Content-Type": "application/json", },});
        console.log('response ka data',response)
        if (response.status === 'UPDATED')
            setshowloader(false)
            console.log('response ka data aagya h ',response)
            addAvailBtn();
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
};

return (
    <React.Fragment>
        {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
            </div>
    <div className="page-content">
        <Container fluid={true}>
        <Breadcrumbs title="Expert" breadcrumbItem=" Package" />

        <Row>
            <Col md={4}>
                <Card className="rounded-4">
                    <CardBody>
                    <p className="font-size-15 pb-2 mb-4 border-bottom text-dark fw-medium">Current Packages</p>
                    <Row>
                        {packages.map((pkg) => (
                        <Col lg={6} xl={4} key={pkg.id}>
                            <Card className="border bg-primary rounded-4 mb-4">
                            <CardBody className="position-relative p-4">
                                <span className="bg-dark rounded-4 mb-2 px-3 py-1 font-size-12 text-white timePriceTag">
                                {pkg.price}
                                </span>
                                <p className="font-size-13 text-white mb-0">{pkg.duration}</p>
                            </CardBody>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                    </CardBody>
                </Card>
                <Card className="rounded-4">
                    <CardBody>
                        <p className="font-size-15 pb-2 mb-4 border-bottom text-dark fw-medium">Set Your Cancellation Policy</p>
                        <p>Define how many hours before the booking a user can cancel.</p>
                        <div className="d-flex gap-2 align-items-center">
                            <input
                                type="test"
                                className="form-control"
                                placeholder="Enter Value in Hours"
                                value={hours}
                                onChange={handleCpolicy}
                            />
                            <Button color="primary" className="btn" onClick={saveHours}>
                                Save
                            </Button>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Col md={8}>
            <Card className="rounded-4 h-100">
                <CardBody>
                <div className="d-flex justify-content-between pb-2 mb-4 border-bottom align-items-center">
                    <p className="font-size-15 text-dark fw-medium mb-0">Add / Edit Packages<span className="text-danger px-1">*</span></p>
                </div>
                <div className="px-3">
                    {durationPriceInputs.map((input) => (
                    <Row 
                        key={input.id}
                        className="shadow-sm border rounded-4 py-4 px-2 align-items-center settinginputHeight bg-light-blue mb-4"
                    >
                        <Col sm={5} className="mb-sm-0 mb-2">
                        <div className="d-flex w-100 align-items-center">
                            <i className="bx bx-time-five me-2 font-size-20"></i>
                            <div className="form-floating w-100">
                            <input
                                type="number"
                                className="form-control"
                                id={`duration-${input.id}`}
                                placeholder=""
                                value={input.duration}
                                onChange={(e) => handleInputChange(input.id, "duration", e.target.value)}
                            />
                            <label htmlFor={`duration-${input.id}`}>Duration (Minutes)</label>
                            </div>
                        </div>
                        </Col>
                        <Col sm={5} className="mb-sm-0 mb-2">
                        <div className="d-flex w-100 align-items-center">
                            <i className="bx bx-dollar me-2 font-size-20"></i>
                            <div className="form-floating w-100">
                            <input
                                type="number"
                                className="form-control"
                                id={`price-${input.id}`}
                                placeholder=""
                                value={input.price}
                                onChange={(e) => handleInputChange(input.id, "price", e.target.value)}
                            />
                            <label htmlFor={`price-${input.id}`}>Price ($)</label>
                            </div>
                        </div>
                        </Col>
                        <Col sm={2}>
                        <div className="d-flex w-100 justify-content-sm-center justify-content-end">
                            <Button
                            color="danger"
                            className="btn me-2"
                            onClick={() => removeDurationPriceInput(input.id)}
                            >
                            Remove
                            </Button>
                        </div>
                        </Col>
                    </Row>
                    ))}
                    <div className="d-flex justify-content-end">
                    <Button
                        color="secondary"
                        className="btn me-2"
                        onClick={addDurationPriceInput}
                    >
                        + Add Time & Price
                    </Button>
                    <Button color="primary" className="btn" onClick={savePackages}>
                        Save
                    </Button>
                    </div>
                </div>
                </CardBody>
            </Card>
            </Col>
        </Row>
        </Container>
    </div>
    </React.Fragment>
);
}

export default Exp_package;